import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const DynamicAccordion = ({ accordionData, viewReport, showSurveyForm }) => {
  const navigate = useNavigate();
  return (
    <div className='dynamic-accordion'>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", 
          alignItems: "center", 
          marginBottom: 20,
        }}
      >
        <div className="heading" style={{ textAlign: "center", flex: 1 }}>
          Registered Kits
        </div>
        <Button className="reportButton" style={{ marginLeft: "auto" }} title="Register New Kit" onClick={() => navigate('/survey')}>
          Register Kit
        </Button>
      </div>
      {accordionData && accordionData.length > 0 ? (
        accordionData.map((data, index) => (
        <Row style={{ marginLeft: 25 }} key={index}>
          <Col sm={2}><b>Kit ID :</b> {data.Kit_id}</Col>
          <Col sm={2}><b>Pet Name :</b> {data.PetName}</Col>
          <Col sm={2}><b>Gender :</b>{data.Gender}</Col>
          <Col sm={2} style={{ marginTop: -10, paddingRight: 35 }}>
            <Button className='reportButton' onClick={() => viewReport(data)}>View Report</Button>
          </Col>
          <Col sm={2} style={{ marginTop: -10, paddingRight: 35 }}>
            <Button className='reportButton' onClick={() => showSurveyForm(data)}>View / Edit Survey</Button>
          </Col>
        </Row>
      ))
      ) : (
        <p style={{ textAlign: 'center', color: '#718096', marginTop: '20px' }}>No registered kits found. Register your first kit above.</p>
      )}
    </div>

  );
};

export default DynamicAccordion;
